import React, { useImperativeHandle, useState } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Typography } from '@material-ui/core';
import Controls from './Controls';

interface ModalProps {
    title: string;
    children: React.ReactNode;
}

export interface ModalHandle {
    handleOpen: () => void;
}

const Modal: React.ForwardRefRenderFunction<ModalHandle, ModalProps> = (props, ref) => {

    const { title } = props;

    const [open, setOpen] = useState(false);

    useImperativeHandle(ref, () => {
        return {
            handleOpen
        }
    })

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <div>
            <Dialog
                open={open}
                maxWidth='md'
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title"  >
                    <Typography variant="h6"  component={'span'}  align="center">{title}</Typography>
                </DialogTitle>
                <DialogContent>
                    <React.Fragment>
                        {props.children}
                    </React.Fragment>
                </DialogContent>
                <DialogActions>
                    <Controls.Button text="Fechar" type="BlankNoBorder" onClick={handleClose} />
                </DialogActions>
            </Dialog>
        </div>
    );
}

export default React.forwardRef(Modal)